import { Box, TableCell } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { FIELD_TYPES } from '../../../../utility/constants'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'

const TableCellDate = ({ color, isHidden, value, type, width }) => {
  const { previewText } = useResponsiveTypography()
  return (
    <TableCell
      sx={{
        width: width + 'rem',
        color: color,
        display: isHidden ? 'none' : '',
        fontSize: previewText,
      }}
    >
      <Box
        sx={{
          overflow: 'auto',
        }}
      >
        {value?.length > 0
          ? FIELD_TYPES.DATE == type
            ? moment(new Date(value)).format('DD MMM YYYY')
            : moment(new Date(value)).format('DD MMM YYYY, hh:mm A')
          : ''}
      </Box>
    </TableCell>
  )
}

export default TableCellDate
